const SECRET_STORAGE_KEY = "portfolio-secret-access";
const SECRET_CODE = "Hello";

export const getSecretAccess = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return window.sessionStorage.getItem(SECRET_STORAGE_KEY) === "granted";
};

export const grantSecretAccess = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.sessionStorage.setItem(SECRET_STORAGE_KEY, "granted");
};

export const revokeSecretAccess = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.sessionStorage.removeItem(SECRET_STORAGE_KEY);
};

export const matchesSecretCode = (value) => value.trim() === SECRET_CODE;
